.scrollWrapper {
	overflow-y: auto;
	width: 100%;
	padding: 0.25rem 0.125rem 0.935rem 0.125rem;
}

.listContainer {
	overflow: hidden;
	width: 100%;
	border-radius: 8px;
	border: 1px solid #efefef;
	display: flex;
	flex-direction: column;
	gap: 0;
	padding: 0;
	margin: 0;
	box-sizing: border-box;
}

.listGroupContainer {
	display: flex;
	flex-direction: column;
	gap: 0;
	width: 100%;
	list-style: none;
}

.listGroupRow {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	gap: 1rem;
	padding: 0.625rem 1.25rem;
	box-sizing: border-box;

	& .listGroupTitleWrapper {
		display: flex;
		flex-direction: row;
		gap: 0.5rem;
		align-items: center;
		padding-left: 0.125rem;
		box-sizing: border-box;

		& .arrow {
			width: 16px;
			height: 16px;
			color: #6b6b6b;
			transform: rotate(180deg);
			&.expanded {
				transform: unset;
			}
		}

		& :global(.MuiTypography-root) {
			color: #212121;
			font-size: 0.875rem;
			font-weight: 600;
			line-height: 1.6;
			letter-spacing: -0.15px;
		}
	}

	& .countChip {
		border-radius: 30px;
		height: 20.5px;
		min-height: fit-content;
		width: fit-content;
		min-width: unset;
		padding: 0.125rem 0.5rem;

		& span {
			color: #515151;
			font-size: 0.75rem;
			line-height: 1.6;
			font-weight: 600;
			letter-spacing: 0.06;
			padding: 0;
		}
	}
}

.listRowContainer {
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 0.625rem 1.25rem;
	box-sizing: border-box;

	& .labelWrapper {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 0.5rem;
		width: 100%;
		min-width: 0;
		flex: 1;
		overflow: hidden;
		padding: 0.125rem;
		box-sizing: border-box;
	}

	& .rowLabel {
		color: #575757;
		font-weight: 400;
		line-height: 0.935rem;
		line-height: 1.5;
		letter-spacing: 0;
	}
}

/* This targets any Row or Group that comes immediately after another Row or Group */
.listRowContainer + .listRowContainer,
.listRowContainer + .listGroupContainer,
.listGroupContainer + .listRowContainer,
.listGroupContainer + .listGroupContainer,
.listGroupRow + .listRowContainer {
	border-top: 1px solid #efefef;
}

@media (max-width: 768px) {
	.listContainer {
		overflow-x: auto;
	}

	.listRowContainer {
		width: fit-content;

		& .labelWrapper {
			width: unset;
			min-width: unset;
			overflow: unset;
		}
	}
}
